class MortgageCalculator {
    constructor(form) {
        this.form = form && form.closest('form');
        this.resultHolder = this.form && this.form.querySelector('[data-result-holder]');
        this.valueHolder = null;
        this.realEstatePriceHolder = null;
        this.activeStep = 1;
        this.nextStepBtn = null;

        this.mortgage = 10000000;
        this.years = 30;
        this.interestRate = this.form.querySelector('[data-interest-rate]') ? parseFloat(this.form.querySelector('[data-interest-rate]').getAttribute('data-interest-rate')) : 1.59;
        this.calculatorFields = null;

        this._init();
    }

    _parseNumericValue(value) {
        return !isNaN(parseInt(value.replace(/\s/g, ""))) ? parseInt(value.replace(/\s/g, "")) : 0;
    }

    _formatSimpleInput(input) {
        const value = this._parseNumericValue(input.value);
        input.value = value.toLocaleString("cs-CZ", {
            style: "decimal",
            maximumFractionDigits: 2
        });
    }

    _toggleStep(target) {
        const steps = Array.from(this.form.querySelectorAll('[data-step]')),
            targetStep = steps.find(e => parseInt(e.dataset.step) === parseInt(target));

        if(!targetStep)
            return;

        steps.forEach(step => step.classList.remove('is-active'));
        targetStep.classList.add('is-active');
        this.activeStep = target;
    }

    _initComponents() {
        this.form.querySelectorAll('[data-calculator-range]').forEach(slider => {
            const sliderInput = slider.closest('.MortgageCalc-row').querySelector('input[name="'+ slider.dataset.id +'"]');

            noUiSlider.create(slider, {
                behaviour: 'snap',
                start: sliderInput.value ?? (parseInt(slider.dataset.start ?? 20)),
                connect: 'lower',
                range: {
                    'min': parseInt(slider.dataset.min ?? 1),
                    'max': parseInt(slider.dataset.max ?? 40)
                },
                ariaFormat: wNumb({
                    decimals: 0
                }),
                format: wNumb({
                    decimals: 0,
                    thousand: " "
                })
            });

            slider.noUiSlider.on('update', (values, handle) => {
                sliderInput.value = values[handle];
            });

            slider.noUiSlider.on('change', () => sliderInput.dispatchEvent(new Event('change')));
            sliderInput.addEventListener('change', () => slider.noUiSlider.set(sliderInput.value));

            sliderInput.slider = slider.noUiSlider;
        });
    }

    _applyInterestRate(rate) {
        this.form.querySelectorAll('[data-interest-rate]').forEach(el => { el.textContent = rate });
        this._reCalculate();
    }

    _readCalculatorData() {
        this.calculatorFields = Array.from(this.form.querySelectorAll('[data-calculator-field]'));
        this.calculatorFields.forEach(field => this._processFieldChange(field, false));
        this.valueHolder = this.calculatorFields.find(e => e.dataset.calculatorField === 'mortgage');
        this.realEstatePriceHolder = this.form.querySelector('[data-real-estate-price-input]');
        this.nextStepBtn = this.form.querySelector('button[data-next-step]');
    }

    _processFieldChange(field, recalculate = true) {
        const fieldName = field.dataset.calculatorField;
        if(!fieldName) return;

        this[fieldName] = this._parseNumericValue(field.value);
        recalculate && this._reCalculate();
    }

    _reCalculate() {
        if (!this.mortgage || !this.years || !this.interestRate) {
            this._setResult(0);
            return;
        }
        const totalMonths = parseInt(this.years, 10) * 12;
        const q = parseFloat(this.interestRate) / 100 / 12;
        const qn = (1 + q) ** totalMonths;
        this._setResult(Math.round((parseInt(this.mortgage, 10) * q * qn) / (qn - 1) || 0));
    }

    _setResult(result) {
        const valid = result > 0;
        this.resultHolder.textContent = valid ? formatCena(result) + ' Kč' : 'hypotéka nelze sjednat';
        this.nextStepBtn.disabled = !valid;
    }

    _setMortgageLimit(limit) {
        const min = this.valueHolder.slider.options.range.min,
            isMinimum = min === limit;

        if(isMinimum) {
            limit++;
            this.valueHolder.slider.target.setAttribute('disabled', isMinimum);
            this.valueHolder.slider.set(min);
        } else {
            this.valueHolder.slider.target.removeAttribute('disabled');
        }

        this.valueHolder.slider.updateOptions({range: {'min': min, 'max' : limit}}, true);
        this.valueHolder.disabled = isMinimum;
        this._processFieldChange(this.valueHolder);
    }

    _addEventListeners() {
        this.form.querySelectorAll('button[data-next-step]').forEach((el) => el.addEventListener('click', (e) => this._toggleStep(e.target.dataset.nextStep)));
        this.calculatorFields.forEach(field => field.addEventListener('change', () => this._processFieldChange(field)));
        this.realEstatePriceHolder && this.realEstatePriceHolder.addEventListener('change', () => this._setMortgageLimit(this._parseNumericValue(this.realEstatePriceHolder.value)));
        this.form.addEventListener('submit', () => this._processBeforeSubmit());
    }

    _processBeforeSubmit() {
        this.realEstatePriceHolder.value = formatCena(this.realEstatePriceHolder.value);
        this.form.querySelector('input#monthly-payment').value = this.resultHolder.textContent;
        return true;
    }

    _init() {
        if(!this.form)
            return;

        this._readCalculatorData();
        this._initComponents();
        this._addEventListeners();
        this._reCalculate();

        if(window.location.hash && (this.form.querySelectorAll('.errors').length || this.form.querySelectorAll('#captchaimage').length))
            this._toggleStep(2);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MortgageCalculator(document.querySelector('[data-mortgage-calculator]'));
    document.querySelectorAll('button[data-refresh-calculator]').forEach(btn => btn.addEventListener('click', () => {
        window.location = window.location.href.split("#")[0];
    }));
})
